
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { InputWithErrors, InputRadio } from '../../lib/forms';

import { products } from '../../services';


class ManageVoicemailForm extends Component {
  constructor() {
    super();
    this.state = {
      voicemailactive: false,
      email: '',
    }
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const {  ProductId } = this.props;
    products.getVoiceMailInfo(ProductId)
    .then((res) => {
    if (res.body.data.voiceMail) {
      this.setState({ voicemailactive: true })
      this.props.changeFieldValue('answeringMachin', this.state.voicemailActive)
      if (res.body.data.voiceMail.Data.vmEmail) {
        this.setState({ sendToMail: true, email: res.body.data.voiceMail.Data.vmEmail })
      }
    }
    })
  }
  handleChange(){
    this.setState({ voicemailactive: !this.state.voicemailactive })
    this.props.changeFieldValue('answeringMachin', this.state.voicemailActive)
  }
  render () {
    const { translate, handleSubmit, cancel } = this.props;
    const { voicemailactive, email } = this.state
    const placeHolderEmail = email ? email : `${translate('insert-email')} . . .`
    return(
      <form className="ng-pristine ng-valid" onSubmit={handleSubmit}>
        <div className="form-group row">
          <label className="col-12 col-md-7  font-weight-bold">{translate('your-answering-machine')}</label>
          <div className="col-12 col-md-5">
              <Field name="answeringMachin" radioName="answering-machin" label="nom" active={voicemailactive} onChange={this.handleChange}  component={InputRadio}  className="form-control" type="date"  />
          </div>
        </div>

        <div className="form-group row">
          <label className="col-12 col-md-7  font-weight-bold">{translate('email-address-receiving-your-voice-messages')}</label>
          <div className="col-12 col-md-5">
            <Field name="email" label="nom" placeholder={placeHolderEmail} translate={translate} component={InputWithErrors}  className="form-control" type="email"  />
          </div>
        </div>
        <div className="form-group row form-group-warning">
          <div className="col"><small className="form-text text-muted"><strong>{translate('important-information')}:</strong><span className="ml-1">{translate('not-receive-voice-messages-alert')}</span></small></div>
        </div>
        <div className="row-btn form-line edit">
        <div className="row justify-content-end row-btn">
          <div className="col-6 col-md-3">
            <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel() }>{translate('cancel')}</button>
          </div>
          <div className="col-6 col-md-3">
            <button className="btn btn-block btn-form btn-submit btn-submit-save " type="submit"  >{translate('save')}</button>
          </div>
        </div>
        </div>
      </form>
    )
  }
}
const viewMapStateToProps = (state) => {
  if (state.form.voicemail) {
    if (state.form.voicemail.values) {
        return {
          translate: getTranslate(state.locale),
          currentLanguage: getActiveLanguage(state.locale).code,
          answeringMachin: state.form.voicemail.values.answeringMachin

      }
    }
  }

  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    answeringMachin: state.form.voicemail ? state.form.voicemail.values : 1,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {

    changeFieldValue: (field, value) => {
      dispatch(
        change('voicemail', field, value)
      );
    },

    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};
ManageVoicemailForm = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(ManageVoicemailForm);
 ManageVoicemailForm = reduxForm({
  form: 'voicemail',
})(ManageVoicemailForm)



class ManageVoicemailFormHandler extends Component {
  constructor() {
    super();
    this.state = {
      voicemailactive: '',
      sendToMail: false,
      email: "",
    }
  }
  componentDidMount() {
    const { rest } = this.props;
    products.getVoiceMailInfo(rest.computedMatch.params.userProductId)
    .then((res) => {
    if (res.body.data.voiceMail) {
      this.setState({ voicemailactive: "1" })
      this.props.changeFieldValue('answeringMachin', this.state.voicemailActive)
      if (res.body.data.voiceMail.Data.vmEmail) {
        this.setState({ sendToMail: true, email: res.body.data.voiceMail.Data.vmEmail })
      }
    }
    })
  }
  handleSubmit(values) {
    const { history, rest, setFlashMessage, translate } = this.props;
    const { voicemailactive } = this.state;
    if (values.email != this.state.email) {
      products.updateVoiceMailEmail(rest.computedMatch.params.userProductId, values.email)
      .then((res) => {
        setFlashMessage(`${translate('changes-saved-successfully')}`, true)
        history.goBack();
      })
      .catch((error) => {
        this.props.setFlashMessage('err', false)
      })
    } else if (voicemailactive != values.answeringMachin) {
      products.updateVoiceMailStatus(rest.computedMatch.params.userProductId)
      .then((res) => {
        setFlashMessage(`${translate('changes-saved-successfully')}`, true)
      })
      .catch((error) => {
        this.props.setFlashMessage('err', false)
      })
    }
  }
   cancel(values) {
     const { history } = this.props;
     history.goBack();
   }
  render() {
    const {  rest, } = this.props;
    return (
      <div>
        <ManageVoicemailForm  onSubmit={this.handleSubmit.bind(this)} ProductId={rest.computedMatch.params.userProductId} email={this.state.email} cancel={this.cancel.bind(this)} />
      </div>
    );
  }
}

const ManageVoicemailViewMapDispatchToProps = (dispatch) => {
  return {

    changeFieldValue: (field, value) => {
      dispatch(
        change('voicemail', field, value)
      );
    },

    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};

ManageVoicemailFormHandler = connect(
  viewMapStateToProps,
  ManageVoicemailViewMapDispatchToProps,
)(ManageVoicemailFormHandler);

ManageVoicemailFormHandler = withRouter(ManageVoicemailFormHandler);

export default ManageVoicemailFormHandler;



// WEBPACK FOOTER //
// ./src/components/ManageVoicemail/ManageVoicemailForm.js